// Module
var code = "<div class=\"t-popout t-popup c-popout\">\n    <div class=\"c-tooltip c-textBold\">\n        <div ng-bind=\"::context\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;